import type { DocMigration } from "../docMigration";

const migration: DocMigration = {
  id: "20260601_add_labels_to_electrical_devices",
  description: "Add empty labels table to all electrical devices",
  apply(json: any, _warnings: string[], _errors: string[]): any {
    const electricalDevices = json.electricalDevices ?? {};
    for (const id of Object.keys(electricalDevices)) {
      if (!electricalDevices[id].labels) {
        electricalDevices[id].labels = {};
      }
    }
    return json;
  },
};

export default migration;
